import { render, staticRenderFns } from "./ListItemActionDots.vue?vue&type=template&id=79b70001&"
import script from "./ListItemActionDots.vue?vue&type=script&lang=ts&"
export * from "./ListItemActionDots.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports